import { formatMatchedAttributes } from "./formatMatchedAttributes";
import type { ProductHit, TypesenseHit } from "./types";

interface ToProductHitOptions {
  includeMatched?: boolean;
}

function copyOptionalFields(raw: TypesenseHit, hit: ProductHit): void {
  if (raw.productType) hit.category = raw.productType;
  if (raw.description) hit.description = raw.description;
  if (raw.imageUrl) hit.imageUrl = raw.imageUrl;
  if (raw.imageAlt) hit.imageAlt = raw.imageAlt;
  if (typeof raw.startingPrice === "number") hit.startingPrice = raw.startingPrice;
  if (typeof raw.ratingAverage === "number") hit.ratingAverage = raw.ratingAverage;
  if (typeof raw.ratingCount === "number") hit.ratingCount = raw.ratingCount;
  if (raw.plpFlag) hit.plpFlag = raw.plpFlag;
}

export function toProductHit(raw: TypesenseHit, options?: ToProductHitOptions): ProductHit | null {
  if (!raw.sku || !raw.slug || !raw.name) return null;
  const matchedAttributes =
    options?.includeMatched && raw._highlightResult ? formatMatchedAttributes(raw._highlightResult) : [];
  const hit: ProductHit = {
    sku: raw.sku,
    slug: raw.slug,
    name: raw.name,
    displayName: raw.displayName ?? raw.name,
    matchedAttributes,
  };
  copyOptionalFields(raw, hit);
  return hit;
}
